import type { ReactNode } from 'react';

export interface FieldChromeProps {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  optional?: boolean | undefined;
  id: string;
  children: ReactNode;
}

/** Shared label/hint/error scaffold used by every form control. */
export function FieldChrome({
  label,
  hint,
  error,
  optional,
  id,
  children,
}: FieldChromeProps): JSX.Element {
  return (
    <div className="flex flex-col gap-1.5 w-full">
      {label !== undefined && (
        <label
          className="flex items-center justify-between text-sm font-semibold text-zinc-700 dark:text-zinc-300"
          htmlFor={id}
        >
          <span>{label}</span>
          {optional && (
            <span className="text-xs text-zinc-400 dark:text-zinc-500 font-normal">Optional</span>
          )}
        </label>
      )}
      {children}
      {error !== undefined && error !== '' ? (
        <span className="text-xs text-rose-500 dark:text-rose-400 mt-0.5" role="alert">
          {error}
        </span>
      ) : (
        hint !== undefined && <span className="text-xs text-zinc-500 mt-0.5">{hint}</span>
      )}
    </div>
  );
}
